// Date formatting utilities for WIP Tracker

export const formatDate = dateString => {
  if (!dateString) return '';
  
  // Handle Date objects
  if (dateString instanceof Date) {
    if (isNaN(dateString.getTime())) return '';
    return dateString.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC', // Use UTC to avoid timezone conversion
    });
  }
  
  // Handle ISO strings - extract date part to avoid timezone issues
  if (typeof dateString === 'string') {
    // If it's an ISO string with time (e.g., "2025-11-11T05:00:00.000Z")
    // Extract just the date part to avoid timezone conversion
    const datePart = dateString.split('T')[0];
    if (datePart.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const [year, month, day] = datePart.split('-');
      const date = new Date(Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)));
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
      });
    }
    
    // Fallback for other date formats
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC',
    });
  }
  
  return '';
};

export const formatDateForInput = dateString => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const calculateDaysDelay = (reqDate, actualDate) => {
  if (!reqDate || !actualDate) return null;

  const req = new Date(reqDate);
  const actual = new Date(actualDate);

  const diffTime = actual - req;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays > 0 ? diffDays : null; // Only show if delayed
};

export const isPastDue = (reqDate, actualDate) => {
  if (!reqDate || actualDate) return false;

  const req = new Date(reqDate);
  const today = new Date();

  return req < today;
};

export const isOverdue = date => {
  if (!date) return false;
  const dateObj = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return dateObj < today;
};

